import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/org/environments')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/_authenticated/org/environments"!</div>
}
